<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_4_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="building_name">{{ $t('ib_building_name') }}</label>
                                <InputText
                                    id="building_name"
                                    type="text"
                                    v-model="building_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_4_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="location">{{ $t('ib_building_location') }}</label>
                                <InputText
                                    id="location"
                                    type="text"
                                    v-model="location"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                        </div>

                        <!-- <div class="p-field p-col p-mt-2">
              <div class="p-grid">
                <div class="p-field p-col-7 p-lg-7 p-mt-2">
                  <label for="organize">{{ $t("response_agency") }}</label>
                  <InputText
                    id="building_organize"
                    type="text"
                    v-model="selectedOrganize.name"
                    disabled
                  />
                </div>
                <div class="p-field p-lg-4" style="padding-top: 3.5px ;">
                  <Button
                    @click="showOrganize = true"
                    icon="pi pi-ellipsis-h"
                    class="p-button-secondary p-mt-5 p-mr-2"
                  />
                  <Button
                    @click="selectedOrganize = {}"
                    icon="pi pi-times"
                    class="p-button-danger p-mt-5"
                  />
                </div>
              </div>
            </div> -->

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="province_select"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="amphur_select"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="tambon_select"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="buildingTypeOptions">{{ $t('ib_building_type') }}</label>
                                <Dropdown
                                    v-model="buildingTypeSelected"
                                    :options="buildingTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="buildingTypeOptions">
                                        <div v-if="buildingTypeOptions.value">
                                            <div>{{ buildingTypeOptions.value.system_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="buildingTypeOptions">
                                        <div>{{ buildingTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="businessTypeOptions">{{ $t('ib_business_type') }}</label>
                                <Dropdown
                                    v-model="businessTypeSelected"
                                    :options="businessTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="businessTypeOptions">
                                        <div v-if="businessTypeOptions.value">
                                            <div>{{ businessTypeOptions.value.system_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="businessTypeOptions">
                                        <div>{{ businessTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-field p-col p-mt-2">
                            <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    v-if="window.width <= 430"
                                    @click="MobileClearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <Button
                                    v-else
                                    @click="clearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    @click="searchBuildingInfo()"
                                    :label="$t('searchBtn')"
                                    class="p-button-info"
                                    ref="TextBox_5_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="buildingInfo_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? buildingInfo_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                dataKey="building_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลอาคาร/สิ่งปลูกสร้าง-${date}`"
                :rowHover="true"
                :loading="loading"
                :selection.sync="selectedBuildingInfo"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="buildingInfoModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>


                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedBuildingInfo && selectedBuildingInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>


                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/6 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/6 จบ-->
                        </div>
                    </div>
                </template>


                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedBuildingInfo.length === buildingInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center;"> 
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedBuildingInfo.some((item) => item.building_id === slotProps.data.building_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>



                <template #empty>{{ $t('TableEmpty') }}</template>

                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <!-- <div hidden>{{ dataTable.data.index }}</div> -->
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                    <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_building_name == true">
                    <Column
                        field="building_name"
                        :header="$t('ib_building_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_building_name == true">
                                {{ dataTable.data.building_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_type_name == true">
                    <Column
                        field="type_name"
                        :header="$t('ib_building_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_type_name == true">
                                {{ dataTable.data.type_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_business_name == true">
                    <Column
                        field="business_name"
                        :header="$t('ib_business_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_business_name == true">
                                {{ dataTable.data.business_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column
                        field="organize_name"
                        :header="$t('response_agency')"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_organize_name == true">
                                {{ dataTable.data.organize_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!-- <Column
          field="building_soi"
          :header="$t('ib_building_location')"
          :sortable="true"
          headerStyle="width: 300px"
        >
          <template #body="dataTable">
            <div class="p-grid">
              <div v-if="dataTable.data.building_no != ''">
                {{ $t("ib_building_location_no") }}
                {{ dataTable.data.building_no }}
              </div>
              <div v-if="dataTable.data.building_moo_number != ''">
                {{ $t("ib_building_location_moo") }}
                {{ dataTable.data.building_moo_number }}
              </div>
              <div v-if="dataTable.data.building_mooban != ''">
                {{ $t("ib_building_location_mooban") }}
                {{ dataTable.data.building_mooban }}
              </div>
              <div v-if="dataTable.data.building_soi != ''">
                {{ $t("ib_building_location_soi") }}
                {{ dataTable.data.building_soi }}
              </div>
              <div v-if="dataTable.data.building_road != ''">
                {{ $t("ib_building_location_road") }}
                {{ dataTable.data.building_road }}
              </div>
              <div v-if="dataTable.data.tambon_id != null">
                {{ $t("tambon") }} {{ dataTable.data.tambon_name }}
                {{ $t("amphur") }} {{ dataTable.data.amphur_name }}
                {{ $t("province") }} {{ dataTable.data.province_name }}
                {{ dataTable.data.postcode }}
              </div>
              <div v-else>-</div>
            </div>
          </template>
        </Column> -->
                <div v-if="columns_building_floor == true">
                    <Column
                        field="building_floor"
                        :header="$t('ib_building_location_floor')"
                        :sortable="true"
                        :headerStyle="tableColSticky('120px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_building_floor == true">
                                <div v-if="dataTable.data.building_floor == 0" class="table_row">ไม่ระบุ</div>
                                <div v-else class="table_row">{{ dataTable.data.building_floor }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_sum_address == true">
                    <Column
                        field="sum_address"
                        :header="$t('ib_building_location')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_sum_address == true">
                                {{ dataTable.data.sum_address }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <Column
          field="building_no"
          :header="$t('ib_building_location_no')"
          :sortable="true"
          headerStyle="width: 120px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.building_no !='' && dataTable.data.building_no !=null ">{{ dataTable.data.building_no }}</div>
            <div v-else>{{ '-'}}</div>
          </template>
        </Column>
         <Column
          field="building_moo_number"
          :header="$t('ib_building_location_moo')"
          :sortable="true"
          headerStyle="width: 120px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.building_moo_number !='' && dataTable.data.building_moo_number !=null ">
            {{ dataTable.data.building_moo_number }}
            </div>
            <div v-else>{{ '-'}}</div>
          </template>
        </Column>
         <Column
          field="building_mooban"
          :header="$t('ib_building_location_mooban')"
          :sortable="true"
          headerStyle="width: 120px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.building_mooban !='' && dataTable.data.building_mooban !=null ">
            {{ dataTable.data.building_mooban }}
            </div>
            <div v-else>{{ '-'}}</div>
          </template>
        </Column>
        <Column
          field="building_soi"
          :header="$t('ib_building_location_soi')"
          :sortable="true"
          headerStyle="width: 150px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.building_soi !='' && dataTable.data.building_soi !=null ">
            {{ dataTable.data.building_soi }}
            </div>
            <div v-else>{{ '-'}}</div>
          </template>
        </Column>
        <Column
          field="building_road"
          :header="$t('ib_building_location_road')"
          :sortable="true"
          headerStyle="width: 150px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.building_road !='' && dataTable.building_road !=null ">
            {{ dataTable.building_road }}
            </div>
            <div v-else>{{ '-'}}</div>
          </template>
        </Column> -->

                <div v-if="columns_building_contact_name == true">
                    <Column
                        field="building_contact_name"
                        :header="$t('contact_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_building_contact_name == true">
                                <div v-if="dataTable.data.building_contact_name == ''">-</div>
                                <div v-else>{{ dataTable.data.building_contact_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_building_contact_phone == true">
                    <!-- <Column
            field="building_contact_phone"
            :header="$t('contact_phone')"
            :sortable="true"
            headerStyle="width: 200px"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.building_contact_phone == ''">-</div>
              <div v-else>{{ dataTable.data.building_contact_phone }}</div>
            </template>
          </Column> -->
                    <Column
                        field="text_tel_detail"
                        :header="$t('contact_phone')"
                        :sortable="true"
                        :headerStyle="tableColSticky('17rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_building_contact_phone == true">
                                <span v-html="dataTable.data.text_tel_detailHTML"></span>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_building_contact_phone ||
                        columns_index ||
                        columns_building_name ||
                        columns_type_name ||
                        columns_business_name ||
                        columns_organize_name ||
                        columns_building_floor ||
                        columns_sum_address ||
                        columns_building_contact_name ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            buildingInfoModal = true;
                                            editData(dataTable.data.building_id);
                                            temp = dataTable.data.building_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.building_id;
                                            deleteTable = '';
                                            alertDisplay(temp, deleteTable);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"> </Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="buildingInfoModal"
            :style="{ width: '98%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ib_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="ib_building_name">{{ $t('ib_building_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="ib_building_name"
                                type="text"
                                v-model="ib_building_name"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_ib_building_name && !ib_building_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_37', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_ib_building_name && !ib_building_name">{{ $t('ib_building_name_validate') }}</small>
                        </div>
                        <div class="p-col" style="display: flex; padding: 0 0">
                            <!-- <div class="p-formgrid p-grid p-col-12"> -->
                            <div class="p-field p-col-9 p-lg-8 p-mt-2">
                                <label for="ib_organize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                                <InputText
                                    id="ib_organize"
                                    type="text"
                                    v-model="ib_organize.name"
                                    disabled
                                    :class="{
                                        'p-invalid': error_ib_building_organize && !ib_organize.name
                                    }"
                                />
                                <small class="p-invalid" v-if="error_ib_building_organize && !ib_organize.name">{{
                                    $t('ib_building_organize_validate')
                                }}</small>
                            </div>
                            <div class="p-field p-mt-2">
                                <Button
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                                <Button
                                    @click="ib_organize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                            </div>
                            <!-- </div> -->
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ib_building_type">{{ $t('ib_building_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ib_building_type"
                                :options="buildingTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :class="{
                                    'p-invalid': error_ib_building_type && !ib_building_type
                                }"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="buildingTypeOptions">
                                    <div v-if="buildingTypeOptions.value">
                                        <div>{{ buildingTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ buildingTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="buildingTypeOptions">
                                    <div>{{ buildingTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ib_building_type && !ib_building_type">{{ $t('ib_building_type_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2" style="margin-top: -5px">
                            <label for="ib_business_type">{{ $t('ib_business_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ib_business_type"
                                :options="businessTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ib_business_type && !ib_business_type
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="businessTypeOptions">
                                    <div v-if="businessTypeOptions.value">
                                        <div>{{ businessTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ businessTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="businessTypeOptions">
                                    <div>{{ businessTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ib_business_type && !ib_business_type">{{ $t('ib_business_type_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ib_use_type">{{ $t('ib_use_type') }} <span class="required-input"></span></label>
                            <Dropdown
                                v-model="ib_use_type"
                                :options="usageTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="usageTypeOptions">
                                    <div v-if="usageTypeOptions.value">
                                        <div>{{ usageTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ usageTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="usageTypeOptions">
                                    <div>{{ usageTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ib_structure_type">{{ $t('ib_structure_type') }}<span class="required-input"></span></label>
                            <Dropdown
                                v-model="ib_structure_type"
                                :options="structureTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="structureTypeOptions">
                                    <div v-if="structureTypeOptions.value">
                                        <div>{{ structureTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ structureTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="structureTypeOptions">
                                    <div>{{ structureTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-8 p-mt-2"></div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <hr />
                    <h5>{{ $t('ib_topic_building_location_detail') }}</h5>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_no">{{ $t('ib_building_location_no') }}</label>
                            <InputText
                                id="ib_building_location_no"
                                type="text"
                                v-model="ib_building_location_no"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-1 p-mt-2">
                            <label for="ib_building_location_moo">{{ $t('ib_building_location_moo') }}</label>
                            <InputText
                                id="ib_building_location_moo"
                                type="text"
                                v-model="ib_building_location_moo"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-4 p-mt-2">
                            <label for="ib_building_location_mooban">{{ $t('ib_building_location_mooban') }}</label>
                            <InputText
                                id="ib_building_location_mooban"
                                type="text"
                                v-model="ib_building_location_mooban"
                                ref="TextBox_6"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_soi">{{ $t('ib_building_location_soi') }}</label>
                            <InputText
                                id="ib_building_location_soi"
                                type="text"
                                v-model="ib_building_location_soi"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ib_building_location_road">{{ $t('ib_building_location_road') }}</label>
                            <InputText
                                id="ib_building_location_road"
                                type="text"
                                v-model="ib_building_location_road"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_province_select">{{ $t('province') }}</label>
                            <Dropdown
                                v-model="ib_province_select"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_amphur_select">{{ $t('amphur') }}</label>
                            <Dropdown
                                :disabled="ib_isDisabledAmphur == 1"
                                v-model="ib_amphur_select"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_tambon_select">{{ $t('tambon') }}</label>
                            <Dropdown
                                :disabled="ib_isDisabledTambon == 1"
                                v-model="ib_tambon_select"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_postcode">{{ $t('postcode') }}</label>
                            <InputText id="ib_postcode" type="text" v-model="ib_postcode" disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_building_location_landNumber">{{ $t('ib_building_location_landNumber') }}</label>
                            <InputText
                                id="ib_building_location_landNumber"
                                type="text"
                                v-model="ib_building_location_landNumber"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_11', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_building_location_permissDate">{{ $t('ib_building_location_permissDate') }}</label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                yearRange="2000:2050"
                                :locale="th"
                                id="imp_start_workDate"
                                v-model="ib_building_location_permissDate"
                            ></Calendar>
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="ib_building_location_permissOwner">{{ $t('ib_building_location_permissOwner') }}</label>
                            <InputText
                                id="ib_building_location_permissOwner"
                                type="text"
                                v-model="ib_building_location_permissOwner"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_width">{{ $t('ib_building_location_width') }}</label>
                            <InputText
                                id="ib_building_location_width"
                                type="number"
                                step="0.01"
                                min="0.00"
                                v-model="ib_building_location_width"
                                @input="checkChar"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_height">{{ $t('ib_building_location_height') }}</label>
                            <InputText
                                id="ib_building_location_height"
                                type="number"
                                step="0.01"
                                min="0.00"
                                v-model="ib_building_location_height"
                                @input="checkChar"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_depth">{{ $t('ib_building_location_depth') }}</label>
                            <InputText
                                id="ib_building_location_depth"
                                type="number"
                                step="0.01"
                                min="0.00"
                                @input="checkChar"
                                v-model="ib_building_location_depth"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_floor">{{ $t('ib_building_location_floor') }}</label>
                            <InputText
                                id="ib_building_location_floor"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_floor"
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_floor_aboveground">{{ $t('ib_building_location_floor_aboveground') }}</label>
                            <InputText
                                id="ib_building_location_floor_aboveground"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_floor_aboveground"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <label for="ib_building_location_floor_underground">{{ $t('ib_building_location_floor_underground') }}</label>
                            <InputText
                                id="ib_building_location_floor_underground"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_floor_underground"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_totalarea">{{ $t('ib_building_location_totalarea') }}</label>
                            <InputText
                                id="ib_building_location_totalarea"
                                type="number"
                                step="0.01"
                                min="0.00"
                                @input="checkChar"
                                v-model="ib_building_location_totalarea"
                                ref="TextBox_17"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_19', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_habitat">{{ $t('ib_building_location_habitat') }}</label>
                            <InputText
                                id="ib_building_location_habitat"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_habitat"
                                ref="TextBox_18"
                                @keyup.left="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_19', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_20', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_population">{{ $t('ib_building_location_population') }}</label>
                            <InputText
                                id="ib_building_location_population"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_population"
                                ref="TextBox_19"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_20', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_21', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_labor">{{ $t('ib_building_location_labor') }}</label>
                            <InputText
                                id="ib_building_location_labor"
                                type="number"
                                min="0"
                                @input="checkChar"
                                v-model="ib_building_location_labor"
                                ref="TextBox_20"
                                @keyup.left="moveFocus($event, 'TextBox_19', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_21', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_18', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_22', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_chemistry">{{ $t('ib_building_location_chemistry') }}</label>
                            <InputText
                                id="ib_building_location_chemistry"
                                type="text"
                                v-model="ib_building_location_chemistry"
                                ref="TextBox_21"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_22', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_19', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_23', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_lift">{{ $t('ib_building_location_lift') }}</label>
                            <InputText
                                id="ib_building_location_lift"
                                type="text"
                                v-model="ib_building_location_lift"
                                ref="TextBox_22"
                                @keyup.left="moveFocus($event, 'TextBox_21', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_23', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_20', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_25', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_building_location_masterroom">{{ $t('ib_building_location_masterroom') }}</label>
                            <InputText
                                id="ib_building_location_masterroom"
                                type="text"
                                v-model="ib_building_location_masterroom"
                                ref="TextBox_23"
                                @keyup.left="moveFocus($event, 'TextBox_22', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_24', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_21', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_26', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_building_location_greenprint">{{ $t('ib_building_location_greenprint') }}</label>
                            <InputText
                                id="ib_building_location_greenprint"
                                type="text"
                                v-model="ib_building_location_greenprint"
                                ref="TextBox_24"
                                @keyup.left="moveFocus($event, 'TextBox_23', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_25', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_21', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_26', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="ib_building_location_whiteprint">{{ $t('ib_building_location_whiteprint') }}</label>
                            <InputText
                                id="ib_building_location_whiteprint"
                                type="text"
                                v-model="ib_building_location_whiteprint"
                                ref="TextBox_25"
                                @keyup.left="moveFocus($event, 'TextBox_24', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_26', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_22', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_27', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_fireconnection">{{ $t('ib_building_location_fireconnection') }}</label>
                            <InputText
                                id="ib_building_location_fireconnection"
                                type="text"
                                v-model="ib_building_location_fireconnection"
                                ref="TextBox_26"
                                @keyup.left="moveFocus($event, 'TextBox_25', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_27', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_23', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_28', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-6 p-mt-2">
                            <label for="ib_building_location_waterzone">{{ $t('ib_building_location_waterzone') }}</label>
                            <InputText
                                id="ib_building_location_waterzone"
                                type="text"
                                v-model="ib_building_location_waterzone"
                                ref="TextBox_27"
                                @keyup.left="moveFocus($event, 'TextBox_26', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_28', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_25', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_29', 'Input')"
                            />
                        </div>
                    </div>

                    <hr />
                    <h5>{{ $t('ib_topic_parking_detail') }}</h5>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_topic_parking_width">{{ $t('ib_topic_parking_width') }}</label>
                            <InputText
                                id="ib_topic_parking_width"
                                type="number"
                                step="0.01"
                                min="0.00"
                                @input="checkChar"
                                v-model="ib_topic_parking_width"
                                ref="TextBox_28"
                                @keyup.left="moveFocus($event, 'TextBox_27', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_29', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_26', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_30', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_topic_parking_length">{{ $t('ib_topic_parking_length') }}</label>
                            <InputText
                                id="ib_topic_parking_length"
                                type="number"
                                step="0.01"
                                min="0.00"
                                @input="checkChar"
                                v-model="ib_topic_parking_length"
                                ref="TextBox_29"
                                @keyup.left="moveFocus($event, 'TextBox_28', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_30', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_26', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_30', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_topic_parking_open">{{ $t('ib_topic_parking_open') }}</label>
                            <Calendar id="ib_topic_parking_open" v-model="ib_topic_parking_open" :timeOnly="true" :showSeconds="true" />
                        </div>
                        <div class="p-field p-col-6 p-lg-3 p-mt-2">
                            <label for="ib_topic_parking_close">{{ $t('ib_topic_parking_close') }}</label>
                            <Calendar id="ib_topic_parking_close" v-model="ib_topic_parking_close" :timeOnly="true" :showSeconds="true" />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="ib_topic_parking_entrance">{{ $t('ib_topic_parking_entrance') }}</label>
                            <InputText
                                id="ib_topic_parking_entrance"
                                type="text"
                                v-model="ib_topic_parking_entrance"
                                ref="TextBox_30"
                                @keyup.left="moveFocus($event, 'TextBox_29', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_31', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_28', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_31', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-12 p-mt-5">
                            <!-- <div class="p-formgrid p-grid"> -->
                            <div class="p-field-checkbox">
                                <Checkbox
                                    id="ib_topic_parking_helicopter"
                                    name="ib_topic_parking_helicopter"
                                    value="1"
                                    v-model="ib_topic_parking_helicopter"
                                />
                                <label for="ib_topic_parking_helicopter">{{ $t('ib_topic_parking_helicopter') }}</label>
                            </div>
                            <!-- <div class="p-field-checkbox p-ml-5"> -->
                            <div class="p-field-checkbox">
                                <Checkbox
                                    id="ib_topic_parking_fire_protect_system"
                                    name="ib_topic_parking_fire_protect_system"
                                    value="1"
                                    v-model="ib_topic_parking_fire_protect_system"
                                />
                                <label for="ib_topic_parking_fire_protect_system">{{ $t('ib_topic_parking_fire_protect_system') }}</label>
                            </div>
                            <!-- </div> -->
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-6">
                            <label for="ib_contact_name">{{ $t('contact_name') }}</label>
                            <InputText
                                id="ib_contact_name"
                                type="text"
                                v-model="ib_contact_name"
                                ref="TextBox_31"
                                @keyup.left="moveFocus($event, 'TextBox_30', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_32', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_30', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_33', 'Input')"
                            />
                        </div>

                        <!-- <div class="p-field p-col-6 p-lg-6">
              <label for="ib_contact_phone">{{ $t("contact_phone") }}</label>
              <InputText
                id="ib_contact_phone"
                type="text"
                v-model="ib_contact_phone"
                @input="acceptNumberPhone"
                autofocus
              />
            </div> -->

                        <!-- <div class="p-field p-col-6 p-lg-6">
              <label for="ib_contact_phone">{{ $t("contact_phone") }}</label>
              <InputText
                id="ib_contact_phone"
                type="text"
                v-model="ib_contact_phone"
                
                autofocus
              />
            </div> -->

                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)</label>
                            <InputText
                                id="contact_phone"
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                :class="{
                                    'p-invalid': error_contact_phone && contact_phone.length !== 12
                                }"
                                ref="TextBox_32"
                                @keyup.left="moveFocus($event, 'TextBox_31', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_33', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_30', 'Input')"
                                @keyup.down="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_34' : 'TextBox_35', 'Input')
                                "
                            />
                            <small class="p-invalid" v-if="error_contact_phone && contact_phone.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก</small
                            >
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)</label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                autofocus
                                :class="{
                                    'p-invalid': error_contact_phone_office && contact_phone_office.length !== 11
                                }"
                                ref="TextBox_33"
                                @keyup.left="moveFocus($event, 'TextBox_32', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_34' : 'TextBox_35', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_31', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_35', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div
                            class="p-field p-col-12 p-lg-6"
                            style="margin-bottom: 0.8rem"
                            v-if="contact_phone_office && contact_phone_office !== '-'"
                        >
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                ref="TextBox_34"
                                @keyup.left="moveFocus($event, 'TextBox_33', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_35', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_32', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_35', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem" v-else>
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                disabled
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                placeholder="กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)"
                                ref="TextBox_34"
                                @keyup.left="moveFocus($event, 'TextBox_33', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_35', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_32', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_35', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-12">
                            <label for="ib_survey">{{ $t('ib_survey') }}</label>
                            <Textarea
                                id="ib_survey"
                                type="text"
                                rows="4"
                                v-model="ib_survey"
                                ref="TextBox_35"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_34' : 'TextBox_33', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_36', 'Button')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_34' : 'TextBox_32', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_36', 'Button')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_36"
                    @keyup.left="moveFocus($event, 'TextBox_35', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_37', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_35', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_36"
                    @keyup.left="moveFocus($event, 'TextBox_35', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_37', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_35', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="saveData()"
                    ref="TextBox_37"
                    @keyup.left="moveFocus($event, 'TextBox_36', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_35', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button
                    :label="$t('confirmBtn')"
                    icon="pi pi-check"
                    deleteTable=""
                    @click="confirmDelete(temp, deleteTable)"
                    class="p-button-text"
                    autofocus
                />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-building',
    components: {
        organizeTable,
        organizeForm,
        textFooter
    },
    data() {
        return {
            temp: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/6
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            loading: false,
            buildingInfo_Table: [],
            filters: {},
            selectedBuildingInfo: [],
            selectedData: '',
            showOrganize: false,
            showOrganize_Form: false,
            selectedOrganize: {},
            location: '',
            building_name: '',
            displayConfirmation: false,

            structureTypeOptions: [],
            usageTypeOptions: [],
            businessTypeOptions: [],
            businessTypeSelected: null,
            buildingTypeOptions: [],
            buildingTypeSelected: null,
            provinceOptions: [],
            province_select: null,
            amphurOptions: [],
            amphur_select: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            tambon_select: null,
            isDisabledTambon: 1,

            buildingInfoModal: false,
            header: this.$i18n.t('ib_modal_title_add'),
            ib_building_name: '',
            ib_organize: {},
            ib_building_type: null,
            ib_business_type: null,
            ib_use_type: null,
            ib_structure_type: null,
            ib_building_location_no: '',
            ib_building_location_moo: '',
            ib_building_location_mooban: '',
            ib_building_location_soi: '',
            ib_building_location_road: '',
            ib_province_select: null,
            ib_isDisabledAmphur: 1,
            ib_tambon_select: null,
            ib_isDisabledTambon: 1,
            ib_amphur_select: null,
            ib_postcode: '',
            ib_building_location_landNumber: '',
            ib_building_location_permissDate: '',
            ib_building_location_permissOwner: '',
            ib_building_location_width: 0,
            ib_building_location_height: 0,
            ib_building_location_depth: 0,
            ib_building_location_floor: 0,
            ib_building_location_floor_aboveground: 0,
            ib_building_location_floor_underground: 0,
            ib_building_location_totalarea: 0,
            ib_building_location_habitat: 0,
            ib_building_location_population: 0,
            ib_building_location_labor: 0,
            ib_building_location_chemistry: '',
            ib_building_location_lift: '',
            ib_building_location_masterroom: '',
            ib_building_location_greenprint: '',
            ib_building_location_whiteprint: '',
            ib_building_location_fireconnection: '',
            ib_building_location_waterzone: '',
            ib_topic_parking_width: 0,
            ib_topic_parking_length: 0,
            ib_topic_parking_open: '',
            ib_topic_parking_close: '',
            ib_topic_parking_entrance: '',
            ib_topic_parking_helicopter: [],
            ib_topic_parking_fire_protect_system: [],
            ib_contact_name: '',
            ib_contact_phone: '',
            ib_survey: '',
            error_ib_building_name: false,
            error_ib_building_type: false,
            error_ib_building_organize: false,
            error_ib_business_type: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            offset: 0,
            totalItemsCount: 0,

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            deleteTable: '',

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            date_create_form: '',
            date_update_form: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่ออาคาร',
                    textShow: ''
                },
                {
                    DataName: 'ที่ตั้งอาคาร',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทอาคาร',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทกิจการ',
                    textShow: ''
                }
            ],

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลอาคาร/สิ่งปลูกสร้าง',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 50,
            PDF_FontHeaderVer: 10,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 30 },
                // building_name: {cellWidth: 60},
                building_floor: { cellWidth: 30 },
                organize_name: { cellWidth: 78 },
                // building_contact_phone:{cellWidth:60},
                text_tel_detail: { cellWidth: 50 },

                date_create_ddmmyy: { cellWidth: 45 },
                date_update_ddmmyy: { cellWidth: 45 }
            },

            PDF_minCellWidthHor: 60,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                building_name: { cellWidth: 60 },
                building_floor: { cellWidth: 40 },
                // building_contact_name:{cellWidth:70},
                text_tel_detail: { cellWidth: 60 }

                // date_create_ddmmyy:{cellWidth:50},
                // date_update_ddmmyy:{cellWidth:55},
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่ออาคาร', dataKey: 'building_name' },
                { title: 'ประเภทอาคาร', dataKey: 'type_name' },
                { title: 'ประเภทกิจการ', dataKey: 'business_name' },
                { title: 'หน่วยงานที่รับผิดชอบ', dataKey: 'organize_name' },
                { title: 'จำนวนชั้น', dataKey: 'building_floor' },
                { title: 'ที่ตั้งอาคาร', dataKey: 'sum_address' },
                { title: 'ชื่อผู้ติดต่อ', dataKey: 'building_contact_name' },
                // {title: "เบอร์โทรศัพท์ผู้ติดต่อ", dataKey: "building_contact_phone"},
                { title: 'เบอร์โทรศัพท์ผู้ติดต่อ', dataKey: 'text_tel_detail' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_building_name: true,
            columns_type_name: true,
            columns_business_name: true,
            columns_organize_name: true,
            columns_building_floor: true,
            columns_sum_address: true,
            columns_building_contact_name: true,
            columns_building_contact_phone: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'building_floor', 'type_name', 'business_name'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'building_floor', 'type_name', 'business_name'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async buildingInfoModal(val) {
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.ib_building_name != '' &&
                    this.ib_organize.name != undefined &&
                    this.ib_building_type != null &&
                    this.ib_business_type != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.buildingInfoModal = false;
                            this.clearData();
                        } else {
                            this.buildingInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-18' }
                        })
                        .then((response) => {
                            (this.buildingTypeOptions = response.data.data),
                                this.buildingTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-19' }
                        })
                        .then((response) => {
                            (this.businessTypeOptions = response.data.data),
                                this.businessTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = this.checkDate_showEN(new Date());
                    this.date_update_form = this.checkDate_showEN(new Date());

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.ib_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-18' }
                    })
                    .then((response) => {
                        this.buildingTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-19' }
                    })
                    .then((response) => {
                        this.businessTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-20' }
                    })
                    .then((response) => {
                        this.usageTypeOptions = response.data.data;
                        // console.log("this.usageTypeOptions",this.usageTypeOptions)
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-21' }
                    })
                    .then((response) => {
                        this.structureTypeOptions = response.data.data;
                    });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.buildingInfoModal = true;
            }
        },

        // check_duplicate(val) {
        //   if (val == "duplicate") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลอาคาร/สิ่งปลูกสร้างไม่สำเร็จ",
        //     //   detail: "มีข้อมูลอาคาร/สิ่งปลูกสร้างนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //      this.$fire({
        //           type: "error",
        //           title: "เพิ่มข้อมูลอาคาร/สิ่งปลูกสร้างไม่สำเร็จ",
        //           text: "มีข้อมูลอาคาร/สิ่งปลูกสร้างนี้ในระบบแล้ว111",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลอาคาร/สิ่งปลูกสร้าง",
        //     //   life: 3000,
        //     // });
        //      this.$fire({
        //           type: "success",
        //           title: "เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลอาคาร/สิ่งปลูกสร้าง11111",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },

        async province_select(val) {
            this.amphur_select = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-amphur', province_id: val.province_id }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.amphur_select = null;
            }
        },

        async amphur_select(val) {
            this.tambon_select = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-tambon', amphur_id: val.amphur_id }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.tambon_select = null;
            }
        },

        async ib_province_select(val) {
            if (val != null) {
                this.ib_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-amphur', province_id: val.province_id }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.ib_isDisabledAmphur = 1;
                this.ib_amphur_select = null;
            }
        },

        async ib_amphur_select(val) {
            if (val != null) {
                this.ib_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-tambon', amphur_id: val.amphur_id }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.ib_isDisabledTambon = 1;
                this.ib_tambon_select = null;
            }
        },

        async ib_tambon_select(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-postcode', tambon_id: val.tambon_id }
                    })
                    .then((response) => (this.ib_postcode = response.data.data.postcode));
            } else {
                this.ib_postcode = '';
            }
        },

        selectedData(val) {
            if (val != '') {
                // if (val.building_usage != "null") {
                //   this.ib_use_type = {
                //     system_id: val.usage_id,
                //     system_name: val.usage_name,
                //   };
                if (val.building_usage.includes('gs-')) {
                    // console.log("val.building_usage----if",val.building_usage)

                    this.ib_use_type = {
                        system_id: val.usage_id,
                        system_name: val.usage_name
                    };
                    // console.log("this.ib_use_type----if",this.ib_use_type)
                } else {
                    // console.log("val.building_usage----else",val.building_usage)
                    // console.log("this.ib_use_type----else",this.ib_use_type)
                    this.ib_use_type = null;
                }

                // if (val.building_structure != "null") {
                //   this.ib_structure_type = {
                //     system_id: val.structure_id,
                //     system_name: val.structure_name,
                //   };
                if (val.building_structure.includes('gs-')) {
                    // console.log("val.building_structure----if",val.building_structure)
                    this.ib_structure_type = {
                        system_id: val.structure_id,
                        system_name: val.structure_name
                    };
                    // console.log("this.ib_structure_type----if",this.ib_structure_type)
                } else {
                    // console.log("val.building_structure----else",val.building_structure)
                    // console.log("this.ib_structure_type----else",this.ib_structure_type)
                    this.ib_structure_type = null;
                }

                if (val.province_id != null) {
                    this.ib_province_select = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.ib_amphur_select = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.ib_tambon_select = {
                        tambon_id: val.tambon_id,
                        tambon_name: val.tambon_name
                    };
                    this.ib_postcode = val.postcode;
                } else {
                    this.ib_province_select = null;
                }
            }
        },
        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.buildingInfo_Table = [];
            } else {
                this.buildingInfo_Table = this.cloneTable;
            }
        },
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
    },

    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        // this.initialData();

        this.checkRole = this.decodeJWT.permission_id;
        this.checkView_data = this.decodeJWT.view_data;
        this.checkAdd_data = this.decodeJWT.add_data;
        this.checkEdit_data = this.decodeJWT.edit_data;
        this.checkDelete_data = this.decodeJWT.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {

        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedBuildingInfo.map((item) => ({
                    building_id: item.building_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/building?user=${userId}`, {
                    body: {
                        topic: 'edit-building_date_multiple',
                        selectedBuildingInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.buildingInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลข้อมูลอาคาร/สิ่งปลูกสร้างจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchBuildingInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedBuildingInfo = [...this.buildingInfo_Table];
            } else {
                this.selectedBuildingInfo = [];
            }
            this.$emit('selectedBuildingInfo', this.selectedBuildingInfo);
            // console.log('selectedBuildingInfo', this.selectedBuildingInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedBuildingInfo.some((item) => item.building_id === row.building_id)) {
                    this.selectedBuildingInfo.push(row);
                }
            } else {
                this.selectedBuildingInfo = this.selectedBuildingInfo.filter((item) => item.building_id !== row.building_id);
            }
            this.$emit('selectedBuildingInfo', this.selectedBuildingInfo);
            // console.log('selectedBuildingInfo', this.selectedBuildingInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_4_search') && !this.isFocused('TextBox_5_search')) {
                    this.searchBuildingInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (!this.isFocused('TextBox_2') && !this.isFocused('TextBox_3') && !this.isFocused('TextBox_36') && !this.isFocused('TextBox_37')) {
                    this.saveData();
                }
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },
        onPage(event) {
            debugger;
            //event.page: New page number
            //event.first: Index of first record
            //event.rows: Number of rows to display in new page
            //event.pageCount: Total number of pages
            console.log(event);
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-18' }
                })
                .then((response) => {
                    (this.buildingTypeOptions = response.data.data),
                        this.buildingTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-19' }
                })
                .then((response) => {
                    (this.businessTypeOptions = response.data.data),
                        this.businessTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // this.ms = true
            if (this.filter != '' && this.buildingInfo_Table !== []) {
                // console.log("4444")
                this.buildingInfo_Table = this.cloneTable.filter((item) => {
                    return (
                        (this.columns_building_name ? item.building_name.includes(this.filter) : '') ||
                        (this.columns_type_name ? item.type_name.includes(this.filter) : '') ||
                        (this.columns_business_name ? item.business_name.includes(this.filter) : '') ||
                        (this.columns_building_floor ? item.building_floor.includes(this.filter) : '') ||
                        (this.columns_sum_address ? item.sum_address.includes(this.filter) : '') ||
                        (this.columns_building_contact_name ? item.building_contact_name.includes(this.filter) : '') ||
                        //  (this.columns_building_contact_phone ? item.building_contact_phone.includes(this.filter) : "") ||
                        (this.columns_building_contact_phone ? item.text_tel_detail.includes(this.filter) : '') ||
                        (this.columns_organize_name ? item.organize_name.includes(this.filter) : '') ||
                        (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                        (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                    );
                });

                for (let i = 0; i < this.buildingInfo_Table.length; i++) {
                    this.buildingInfo_Table[i]['index'] = i + 1;
                    // console.log("this.buildingInfo_Table",this.buildingInfo_Table)
                }

                return this.buildingInfo_Table;
            } else {
                // console.log("5555")
                this.buildingInfo_Table = this.cloneTable;
                for (let i = 0; i < this.buildingInfo_Table.length; i++) {
                    this.buildingInfo_Table[i]['index'] = i + 1;
                }
            }
            this.buildingInfo_Table = this.cloneTable;
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/building`, {
                    body: {
                        topic: 'get-table',
                        userOrg,
                        isDistrict
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.buildingInfo_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    for (let i = 0; i < this.buildingInfo_Table.length; i++) {
                        this.buildingInfo_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.buildingInfo_Table == id  ",this.buildingInfo_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.buildingInfo_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.buildingInfo_Table = this.cloneTable;
            } else {
                this.buildingInfo_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-18' }
                })
                .then((response) => {
                    (this.buildingTypeOptions = response.data.data),
                        this.buildingTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-19' }
                })
                .then((response) => {
                    (this.businessTypeOptions = response.data.data),
                        this.businessTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (
                    data[index].sum_address == null ||
                    data[index].sum_address == 'null' ||
                    data[index].sum_address == '    ' ||
                    data[index].sum_address == ''
                ) {
                    data[index].sum_address = '-';
                }
                if (
                    data[index].building_contact_name == null ||
                    data[index].building_contact_name == 'null' ||
                    data[index].building_contact_name == ''
                ) {
                    data[index].building_contact_name = '-';
                }
                if (
                    data[index].building_contact_phone == null ||
                    data[index].building_contact_phone == 'null' ||
                    data[index].building_contact_phone == ''
                ) {
                    data[index].building_contact_phone = '-';
                }
                if (data[index].type_name == null || data[index].type_name == 'null' || data[index].type_name == '') {
                    data[index].type_name = '-';
                }
                if (data[index].business_name == null || data[index].business_name == 'null' || data[index].business_name == '') {
                    data[index].business_name = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        checkChar(e) {
            if (e == '') {
                this.ib_building_location_width = 0;
                this.ib_building_location_height = 0;
                this.ib_building_location_depth = 0;
                this.ib_building_location_floor = 0;
                this.ib_building_location_floor_aboveground = 0;
                this.ib_building_location_floor_underground = 0;
                this.ib_building_location_totalarea = 0;
                this.ib_building_location_habitat = 0;
                this.ib_building_location_population = 0;
                this.ib_building_location_labor = 0;
                this.ib_topic_parking_width = 0;
                this.ib_topic_parking_length = 0;
            }
        },

        // acceptNumberPhone() {
        //   var x = this.ib_contact_phone
        //     .replace(/\D/g, "")
        //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //   this.ib_contact_phone = !x[2]
        //     ? x[1]
        //     : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        // },
        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.buildingInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.ib_amphur_select = null;
            }
            if (message == 'ch-amphur') {
                this.ib_tambon_select = null;
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.buildingInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.ib_organize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchBuildingInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            debugger;
            // if (this.filter) {
            //   this.loading = false;
            // }else{
            //   this.loading = true;
            // }
            // this.loading = true;

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
            await this.axios
                .post(`${this.$url_service}/initial/building`, {
                    body: {
                        topic: 'search-table',
                        name: this.building_name,
                        location: this.location,
                        // organize: this.checkPermission()
                        //   ? this.selectedOrganize
                        //   : this.getUserOrganize(),
                        province: this.province_select,
                        amphur: this.amphur_select,
                        tambon: this.tambon_select,
                        type: this.buildingTypeSelected,
                        business: this.businessTypeSelected,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        userOrg,
                        isDistrict
                    }
                })
                .then((response) => {
                    debugger;

                    this.buildingInfo_Table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6
                    // console.log("this.buildingInfo_Table == id  ",this.buildingInfo_Table)

                    // Doe : เพิ่ม ลำดับ 4/4
                    for (let i = 0; i < this.buildingInfo_Table.length; i++) {
                        this.buildingInfo_Table[i]['index'] = i + 1;
                    }

                    //  // Doe : เพิ่ม ลำดับ 4/4 จบ

                    // // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.buildingInfo_Table);
                    // this.search()

                    this.setSearchText_Footer();
                });

            if (this.columns_disabled == true) {
                this.buildingInfo_Table = this.cloneTable;
            } else {
                this.buildingInfo_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.building_name !== '' ||
                this.location !== '' ||
                this.province_select !== null ||
                this.amphur_select !== null ||
                this.tambon_select !== null ||
                this.buildingTypeSelected !== null ||
                this.businessTypeSelected !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่ออาคาร' && this.building_name !== '') {
                        element.textShow = this.building_name;
                    }
                    if (element.DataName === 'ที่ตั้งอาคาร' && this.location !== '') {
                        element.textShow = this.location;
                    }
                    if (element.DataName === 'จังหวัด' && this.province_select !== null) {
                        element.textShow = this.province_select.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.amphur_select !== null) {
                        element.textShow = this.amphur_select.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.tambon_select !== null) {
                        element.textShow = this.tambon_select.tambon_name;
                    }
                    if (element.DataName === 'ประเภทอาคาร' && this.buildingTypeSelected !== null) {
                        element.textShow = this.buildingTypeSelected.system_name;
                    }
                    if (element.DataName === 'ประเภทกิจการ' && this.businessTypeSelected !== null) {
                        element.textShow = this.businessTypeSelected.system_name;
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userId = this.getUsername();

            if (this.deleteTable === 'organize') {
                if (this.deleteTable === 'organize') {
                    this.displayConfirmation = false;
                    this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
                }
            } else {
                this.displayConfirmation = false;
                await this.axios
                    .post(`${this.$url_service}/initial/building?user=${userId}`, {
                        body: {
                            topic: 'delete-building',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchBuildingInfo()
                    );
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลอาคาร/สิ่งปลูกสร้าง",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลอาคาร/สิ่งปลูกสร้าง',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];

            if (this.ib_building_name == '' || this.ib_building_type == null || this.ib_business_type == null || this.ib_organize.name == undefined) {
                if (this.ib_building_name == '') {
                    this.error_ib_building_name = true;
                }
                if (this.ib_building_type == null) {
                    this.error_ib_building_type = true;
                }
                if (this.ib_business_type == null) {
                    this.error_ib_business_type = true;
                }
                if (this.ib_organize.name == undefined) {
                    this.error_ib_building_organize = true;
                }
            } else {
                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (!this.error_contact_phone && !this.error_contact_phone_office) {
                    if (this.selectedData == '') {
                        var open, close, permiss_date;
                        if (this.ib_topic_parking_open != '') {
                            const time = new Date(this.ib_topic_parking_open);
                            const h = time.getHours();
                            const m = time.getMinutes();
                            const s = time.getSeconds();
                            open = `${h}:${m}:${s}`;
                        } else {
                            open = null;
                        }
                        if (this.ib_topic_parking_close != '') {
                            const time = new Date(this.ib_topic_parking_close);
                            const h = time.getHours();
                            const m = time.getMinutes();
                            const s = time.getSeconds();
                            close = `${h}:${m}:${s}`;
                        } else {
                            close = null;
                        }
                        if (this.ib_building_location_permissDate != '') {
                            const permiss = new Date(this.ib_building_location_permissDate);
                            const ye = new Intl.DateTimeFormat('en', {
                                year: 'numeric'
                            }).format(permiss);
                            const mo = new Intl.DateTimeFormat('en', {
                                month: '2-digit'
                            }).format(permiss);
                            const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(permiss);
                            permiss_date = `${ye}-${mo}-${da}`;
                        } else {
                            permiss_date = null;
                        }
                        // โหลดเพิ่มแก้ไข 4/8
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 4/8 จบ
                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
                        // const userId = this.decodeJWT.user_id;

                        const userId = this.getUsername();

                        await this.axios
                            .post(`${this.$url_service}/initial/building?user=${userId}`, {
                                body: {
                                    topic: 'add-building',
                                    userOrg,
                                    name: this.ib_building_name,
                                    organize: this.ib_organize.id,
                                    type: this.ib_building_type.system_id,
                                    business: this.ib_business_type.system_id,
                                    use: this.ib_use_type,
                                    structure: this.ib_structure_type,
                                    address_no: this.ib_building_location_no,
                                    address_moo: this.ib_building_location_moo,
                                    address_mooban: this.ib_building_location_mooban,
                                    address_soi: this.ib_building_location_soi,
                                    address_road: this.ib_building_location_road,
                                    address_location: this.ib_tambon_select,
                                    land_no: this.ib_building_location_landNumber,
                                    land_permiss: permiss_date,
                                    land_owner: this.ib_building_location_permissOwner,
                                    width: this.ib_building_location_width,
                                    height: this.ib_building_location_height,
                                    depth: this.ib_building_location_depth,
                                    floor: this.ib_building_location_floor,
                                    floor_above: this.ib_building_location_floor_aboveground,
                                    floor_under: this.ib_building_location_floor_underground,
                                    totalarea: this.ib_building_location_totalarea,
                                    habitat: this.ib_building_location_habitat,
                                    population: this.ib_building_location_population,
                                    labor: this.ib_building_location_labor,
                                    chemical: this.ib_building_location_chemistry,
                                    elevator: this.ib_building_location_lift,
                                    master_room: this.ib_building_location_masterroom,
                                    green_print: this.ib_building_location_greenprint,
                                    white_print: this.ib_building_location_whiteprint,
                                    water_receive: this.ib_building_location_whiteprint,
                                    waterzone: this.ib_building_location_waterzone,
                                    park_width: this.ib_topic_parking_width,
                                    park_length: this.ib_topic_parking_length,
                                    park_opentime: open,
                                    park_closetime: close,
                                    entrance: this.ib_topic_parking_entrance,
                                    helicopter: this.ib_topic_parking_helicopter,
                                    firedisaster: this.ib_topic_parking_fire_protect_system,
                                    contact_name: this.ib_contact_name,
                                    contact_phone: this.ib_contact_phone,
                                    tel_detail: this.iev_phone,
                                    interview: this.ib_survey,
                                    isDistrict
                                }
                            })
                            .then((response) => {
                                (this.check_duplicate = response.data.message),
                                    // this.initialData();
                                    this.searchBuildingInfo();

                                // โหลดเพิ่มแก้ไข 5/8
                                this.loadingCreate = false;
                                // โหลดเพิ่มแก้ไข 5/8 จบ

                                // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                                // console.log("this.check_duplicate ",this.check_duplicate)
                                if (this.check_duplicate == 'duplicate') {
                                    this.$fire({
                                        type: 'error',
                                        title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                        text: 'มีข้อมูลนี้ในระบบแล้ว',
                                        timer: 3000,
                                        confirmButtonColor: '#d33'
                                    });
                                } else {
                                    this.$fire({
                                        title: 'เพิ่มข้อมูลสำเร็จ',
                                        text: 'ข้อมูลอาคาร/สิ่งปลูกสร้าง',
                                        type: 'success',
                                        timer: 3000,
                                        confirmButtonColor: '#28B463'
                                    });
                                }
                            });
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.buildingInfoModal = false;
                    } else {
                        var edit_permissdate;
                        if (this.ib_building_location_permissDate != this.selectedData.building_allowed_date) {
                            if (this.ib_building_location_permissDate != '') {
                                const permiss = new Date(this.ib_building_location_permissDate);
                                const ye_1 = new Intl.DateTimeFormat('en', {
                                    year: 'numeric'
                                }).format(permiss);
                                const mo_1 = new Intl.DateTimeFormat('en', {
                                    month: '2-digit'
                                }).format(permiss);
                                const da_1 = new Intl.DateTimeFormat('en', {
                                    day: '2-digit'
                                }).format(permiss);
                                edit_permissdate = `${ye_1}-${mo_1}-${da_1}`;
                            } else {
                                edit_permissdate = null;
                            }
                        } else {
                            if (this.selectedData.building_allowed_date != null) {
                                const permiss_2 = this.selectedData.building_allowed_date.split('/');
                                const ye_2 = permiss_2[2];
                                const mo_2 = permiss_2[1];
                                const da_2 = permiss_2[0];
                                edit_permissdate = `${ye_2}-${mo_2}-${da_2}`;
                            } else {
                                edit_permissdate = null;
                            }
                        }

                        if (this.ib_topic_parking_open != this.selectedData.building_opentime) {
                            if (this.ib_topic_parking_open != '') {
                                const time = new Date(this.ib_topic_parking_open);
                                const h = time.getHours();
                                const m = time.getMinutes();
                                const s = time.getSeconds();
                                open = `${h}:${m}:${s}`;
                            } else {
                                open = null;
                            }
                        } else {
                            open = this.selectedData.building_opentime;
                        }
                        if (this.ib_topic_parking_close != this.selectedData.building_closetime) {
                            if (this.ib_topic_parking_close != '') {
                                const time = new Date(this.ib_topic_parking_close);
                                const h = time.getHours();
                                const m = time.getMinutes();
                                const s = time.getSeconds();
                                close = `${h}:${m}:${s}`;
                            } else {
                                close = null;
                            }
                        } else {
                            close = this.selectedData.building_closetime;
                        }
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        this.loadingCreate = true;

                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
                        // const userId = this.decodeJWT.user_id;

                        const userId = this.getUsername();
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        await this.axios
                            .post(`${this.$url_service}/initial/building?user=${userId}`, {
                                body: {
                                    topic: 'edit-building',
                                    id: this.temp,
                                    name: this.ib_building_name,
                                    organize: this.ib_organize.id,
                                    type: this.ib_building_type.system_id,
                                    business: this.ib_business_type.system_id,
                                    use: this.ib_use_type,
                                    structure: this.ib_structure_type,
                                    address_no: this.ib_building_location_no,
                                    address_moo: this.ib_building_location_moo,
                                    address_mooban: this.ib_building_location_mooban,
                                    address_soi: this.ib_building_location_soi,
                                    address_road: this.ib_building_location_road,
                                    address_location: this.ib_tambon_select,
                                    land_no: this.ib_building_location_landNumber,
                                    land_permiss: edit_permissdate,
                                    land_owner: this.ib_building_location_permissOwner,
                                    width: this.ib_building_location_width,
                                    height: this.ib_building_location_height,
                                    depth: this.ib_building_location_depth,
                                    floor: this.ib_building_location_floor,
                                    floor_above: this.ib_building_location_floor_aboveground,
                                    floor_under: this.ib_building_location_floor_underground,
                                    totalarea: this.ib_building_location_totalarea,
                                    habitat: this.ib_building_location_habitat,
                                    population: this.ib_building_location_population,
                                    labor: this.ib_building_location_labor,
                                    chemical: this.ib_building_location_chemistry,
                                    elevator: this.ib_building_location_lift,
                                    master_room: this.ib_building_location_masterroom,
                                    green_print: this.ib_building_location_greenprint,
                                    white_print: this.ib_building_location_whiteprint,
                                    water_receive: this.ib_building_location_whiteprint,
                                    waterzone: this.ib_building_location_waterzone,
                                    park_width: this.ib_topic_parking_width,
                                    park_length: this.ib_topic_parking_length,
                                    park_opentime: open,
                                    park_closetime: close,
                                    entrance: this.ib_topic_parking_entrance,
                                    helicopter: this.ib_topic_parking_helicopter,
                                    firedisaster: this.ib_topic_parking_fire_protect_system,
                                    contact_name: this.ib_contact_name,
                                    contact_phone: this.ib_contact_phone,
                                    tel_detail: this.iev_phone,
                                    interview: this.ib_survey,
                                    isDistrict,
                                    userOrg
                                }
                            })
                            .then(() =>
                                // this.initialData()
                                this.searchBuildingInfo()
                            );

                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 7/8 จบ

                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "แก้ไขข้อมูลสำเร็จ",
                        //   detail: `ข้อมูลอาคาร/สิ่งปลูกสร้าง`,
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ',
                            text: `ข้อมูลอาคาร/สิ่งปลูกสร้าง`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.buildingInfoModal = false;
                    }
                }
            }
        },
        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('ib_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/building`, {
                    body: {
                        topic: 'showone-building',
                        id: data
                    }
                })
                .then((response) => {
                    // console.log(response.data.data),
                    (this.selectedData = response.data.data),
                        (this.ib_building_name = response.data.data.building_name),
                        (this.ib_organize = {
                            id: response.data.data.organize_id,
                            name: response.data.data.organize_name
                        }),
                        (this.ib_building_type = {
                            system_id: response.data.data.type_id,
                            system_name: response.data.data.type_name
                        }),
                        (this.ib_business_type = {
                            system_id: response.data.data.business_id,
                            system_name: response.data.data.business_name
                        }),
                        (this.ib_building_location_no = response.data.data.building_no),
                        (this.ib_building_location_moo = response.data.data.building_moo_number),
                        (this.ib_building_location_mooban = response.data.data.building_mooban),
                        (this.ib_building_location_soi = response.data.data.building_soi),
                        (this.ib_building_location_road = response.data.data.building_road),
                        (this.ib_building_location_landNumber = response.data.data.building_land_number),
                        (this.ib_building_location_permissOwner = response.data.data.building_ownership),
                        (this.ib_building_location_permissDate = response.data.data.building_allowed_date),
                        (this.ib_building_location_width = response.data.data.building_width),
                        (this.ib_building_location_height = response.data.data.building_height),
                        (this.ib_building_location_depth = response.data.data.building_depth),
                        (this.ib_building_location_floor = response.data.data.building_floor),
                        (this.ib_building_location_floor_aboveground = response.data.data.building_floor_above),
                        (this.ib_building_location_floor_underground = response.data.data.building_floor_under),
                        (this.ib_building_location_totalarea = response.data.data.building_totalarea),
                        (this.ib_building_location_habitat = response.data.data.building_number_habitat),
                        (this.ib_building_location_population = response.data.data.building_number_resident),
                        (this.ib_building_location_labor = response.data.data.building_number_labor),
                        (this.ib_building_location_chemistry = response.data.data.building_chemical),
                        (this.ib_building_location_lift = response.data.data.building_elevator),
                        (this.ib_building_location_masterroom = response.data.data.building_master_room),
                        (this.ib_building_location_greenprint = response.data.data.building_green_print),
                        (this.ib_building_location_whiteprint = response.data.data.building_white_print),
                        (this.ib_building_location_fireconnection = response.data.data.building_waterhead),
                        (this.ib_building_location_waterzone = response.data.data.building_waterzone),
                        (this.ib_topic_parking_width = response.data.data.building_parking_width),
                        (this.ib_topic_parking_length = response.data.data.building_parking_length),
                        (this.ib_topic_parking_open = response.data.data.building_opentime),
                        (this.ib_topic_parking_close = response.data.data.building_closetime),
                        (this.ib_topic_parking_entrance = response.data.data.building_entrance),
                        (this.ib_topic_parking_helicopter = [response.data.data.building_helicopter]),
                        (this.ib_topic_parking_fire_protect_system = [response.data.data.building_fireprotect]),
                        (this.ib_contact_name = response.data.data.building_contact_name),
                        (this.ib_contact_phone = response.data.data.building_contact_phone),
                        (this.iev_phone = JSON.parse(response.data.data.tel_detail));

                    for (let index = 0; index < this.iev_phone.length; index++) {
                        const element = this.iev_phone[index];
                        this.contact_phone = element.phone;
                        this.contact_phone_office = element.tel;
                        this.contact_phone_office_ext = element.tel_ext;
                        // console.log("element.tel",element.tel)
                    }

                    this.ib_survey = response.data.data.building_interview;

                    this.date_create_form = response.data.data.date_create_ddmmyy == null ? '-' : response.data.data.date_create_ddmmyy;
                    this.date_update_form = response.data.data.date_update_ddmmyy == null ? '-' : response.data.data.date_update_ddmmyy;
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('ib_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.buildingInfoModal = false;
                this.selectedData = '';
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.ib_building_name = '';
            this.ib_organize = {};
            this.ib_building_type = null;
            this.ib_business_type = null;
            this.ib_use_type = null;
            this.ib_structure_type = null;

            this.ib_building_location_no = '';
            this.ib_building_location_moo = '';
            this.ib_building_location_mooban = '';
            this.ib_building_location_soi = '';
            this.ib_building_location_road = '';
            this.ib_province_select = null;

            this.ib_building_location_landNumber = '';
            this.ib_building_location_permissDate = '';
            this.ib_building_location_permissOwner = '';
            this.ib_building_location_width = 0;
            this.ib_building_location_height = 0;
            this.ib_building_location_depth = 0;
            this.ib_building_location_floor = 0;
            this.ib_building_location_floor_aboveground = 0;
            this.ib_building_location_floor_underground = 0;
            this.ib_building_location_totalarea = 0;
            this.ib_building_location_habitat = 0;
            this.ib_building_location_population = 0;
            this.ib_building_location_labor = 0;
            this.ib_building_location_chemistry = '';
            this.ib_building_location_lift = '';
            this.ib_building_location_masterroom = '';
            this.ib_building_location_greenprint = '';
            this.ib_building_location_whiteprint = '';
            this.ib_building_location_fireconnection = '';
            this.ib_building_location_waterzone = '';

            this.ib_topic_parking_width = 0;
            this.ib_topic_parking_length = 0;
            this.ib_topic_parking_open = '';
            this.ib_topic_parking_close = '';
            this.ib_topic_parking_entrance = '';
            this.ib_topic_parking_helicopter = [];
            this.ib_topic_parking_fire_protect_system = [];
            this.ib_contact_name = '';
            this.ib_contact_phone = '';
            this.ib_survey = '';
            this.error_ib_building_name = false;
            this.error_ib_building_type = false;
            this.error_ib_building_organize = false;
            this.error_ib_business_type = false;

            this.tempFor_displayConfirmationCloseModal = '';

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        clearSearchField() {
            this.building_name = '';
            this.location = '';
            this.selectedOrganize = {};
            this.province_select = null;
            this.buildingTypeSelected = null;
            this.businessTypeSelected = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.organize_table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.building_name = '';
                this.location = '';
                this.selectedOrganize = {};
                this.province_select = null;
                this.buildingTypeSelected = null;
                this.businessTypeSelected = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 8;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    // building_floor:{cellWidth: 30},
                    organize_name: { cellWidth: 78 },

                    text_tel_detail: { cellWidth: 50 },

                    date_create_ddmmyy: { cellWidth: 45 },
                    date_update_ddmmyy: { cellWidth: 45 }
                };

                this.PDF_minCellWidthHor = 60;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            } else {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 8;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 60;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_building_name = false;
                this.columns_type_name = false;
                this.columns_business_name = false;
                this.columns_organize_name = false;
                this.columns_building_floor = false;
                this.columns_sum_address = false;
                this.columns_building_contact_name = false;
                this.columns_building_contact_phone = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'building_name') {
                        this.columns_building_name = true;
                    } else if (!getData.includes('building_name')) {
                        this.columns_building_name = false;
                    }

                    if (element == 'type_name') {
                        this.columns_type_name = true;
                    } else if (!getData.includes('type_name')) {
                        this.columns_type_name = false;
                    }

                    if (element == 'business_name') {
                        this.columns_business_name = true;
                    } else if (!getData.includes('business_name')) {
                        this.columns_business_name = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'building_floor') {
                        this.columns_building_floor = true;
                    } else if (!getData.includes('building_floor')) {
                        this.columns_building_floor = false;
                    }

                    if (element == 'sum_address') {
                        this.columns_sum_address = true;
                    } else if (!getData.includes('sum_address')) {
                        this.columns_sum_address = false;
                    }

                    if (element == 'building_contact_name') {
                        this.columns_building_contact_name = true;
                    } else if (!getData.includes('building_contact_name')) {
                        this.columns_building_contact_name = false;
                    }

                    // if (element == "building_contact_phone") {
                    //   this.columns_building_contact_phone = true
                    // }else if(!getData.includes("building_contact_phone")){

                    //   this.columns_building_contact_phone = false
                    // }
                    if (element == 'text_tel_detail') {
                        this.columns_building_contact_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_building_contact_phone = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
